export const initInfinitiveScroll = () => {
  document.querySelectorAll<HTMLElement>("[data-product-grid]").forEach((collectionGrid) => {
    let loading = false;
    const sectionType = collectionGrid.dataset.productGrid;
    const productTotal = +collectionGrid.dataset.productGridTotal;
    const paginationSize = +collectionGrid.dataset.productGridPaginationSize;
    const trigger = collectionGrid.querySelector<HTMLElement>(
      "[data-product-grid-infinitive-scroll-trigger]"
    );
    const productContainer = collectionGrid.querySelector<HTMLElement>(
      "[data-product-grid-container]"
    );

    if (!trigger) {
      return;
    }
    const observer = new IntersectionObserver(
      async (entries) => {
        if (entries[0].isIntersecting) {
          const currentSize = collectionGrid.querySelector<HTMLElement>(
            "[data-product-grid-container]"
          )?.children?.length;

          if (!loading && currentSize < productTotal) {
            loading = true;
            trigger.classList.add("h-12");
            const nextPage = Math.round(currentSize / paginationSize) + 1;
            const section = await fetch(
              `${window.location.pathname}?${window.location.search.replace(
                /^\?/gi,
                ""
              )}&sections=${sectionType}&page=${nextPage}`
            ).then((data) => data.json());
            const dataElement = document.createElement("div");
            dataElement.innerHTML = section[`${sectionType}`];

            [
              ...(dataElement.querySelector("[data-product-grid-container]").children ?? []),
            ].forEach((child) => {
              productContainer.appendChild(child);
            });
            loading = false;
            trigger.classList.remove("h-12");
          }
        }
      },
      { rootMargin: "800px 0px 800px 0px" }
    );
    observer.observe(trigger);
  });
};
